import { Map } from 'immutable';

import typeFilterOptions from '../../constants/typeFilterOptions';

export default Map({
  type: typeFilterOptions[0],
  period: null,
});
